import { useMutation } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { plantDockUrls } from "../../URL/ApplicationUrls";
import { deleteSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { combinedUrls } from "../../URL/functions";
import { PlantDock } from "../PlantDock";

export const useDeleteDock = () =>
  useMutation({
    mutationFn: (dock: PlantDock) =>
      axios.delete<number>(
        combinedUrls(plantDockUrls.docksForPlantWithId(dock.PlantId), dock.Id.toString())
      ),
    onSuccess: async (response: AxiosResponse<number>) => {
      toast.success(deleteSuccessMessage(response.data, "Dock"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
